import { Typography, styled, TypographyProps } from '@mui/material'

// TODO: Implement fade
export const ClampedTypography = styled(Typography, {
  shouldForwardProp: prop => prop !== 'maxLines',
})<{
  maxLines: number
  variant: Exclude<TypographyProps['variant'], 'inherit' | undefined>
}>`
  overflow: hidden;
  max-width: 100%;
  display: -webkit-box;

  -webkit-line-clamp: ${({ maxLines }) => maxLines};
  line-clamp: ${({ maxLines }) => maxLines};

  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  word-wrap: break-word;
  max-height: ${({ variant, theme, maxLines }) =>
    `calc(${theme.typography[variant]?.lineHeight} * ${maxLines})`};

  /* Using padding breaks clamp functionality */
  padding: 0 !important;

  &.fade::after {
    content: '';
    text-align: left;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 20%;
    height: ${({ variant, theme }) => theme.typography[variant]?.lineHeight};
    background: linear-gradient(
      to left,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1) 50%
    );
  }
`
